<script setup lang="ts">
import type { IllustrationKey } from '~/utils/crystallize/cta'

const { name } = defineProps<{ name: IllustrationKey }>()

const url = usePublicAssetUrl(`/illustrations/${name}.svg`)
</script>

<template>
  <img :src="url" :alt="String($attrs.alt) || ''">
</template>
